import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

/**
 * Reusable form input component
 * @param {Object} props
 * @param {string} props.label - Input label
 * @param {string} props.name - Input name
 * @param {string} props.type - Input type
 * @param {string} props.value - Input value
 * @param {Function} props.onChange - Change handler
 * @param {boolean} [props.required] - Required flag
 * @param {string} [props.pattern] - Regex pattern
 * @param {string} [props.error] - Error message
 */
function FormInput({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
  pattern,
  step,
  error,
}) {
  const sanitizedValue = DOMPurify.sanitize(value);

  return (
    <div className="mb-3">
      <label htmlFor={name} className="form-label">
        {label}
      </label>
      <input
        type={type}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        id={name}
        name={name}
        value={sanitizedValue}
        onChange={onChange}
        required={required}
        pattern={pattern}
        step={step}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
}

FormInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  pattern: PropTypes.string,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
};

export default FormInput;
